import { ReactElement } from "react";
import EmailNotFoundView from "views/mail-not-found";

const MailNotFound = (): ReactElement => {
  return <EmailNotFoundView />;
};

export default MailNotFound;
